"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./lib/index'));



//////////////////
// WEBPACK FOOTER
// ./~/angular2-perfect-scrollbar/dist/index.js
// module id = 17
// module chunks = 0 1